import React from "react";
import { useEffect } from "react";

import { MapType } from "../../../../types/dataTypes";
import { mapGetLayerExists, mapCorrectLayerOrder, mapGetSourceExists } from "../../../../utils/mapDataHandler";
import { LAYER_ORDER_ARRAY } from "../../../../utils/mapConsts";
import { COLORS } from "../../../../utils/consts";
import { getGeoJsonByName } from "../../../../services/getGeojsonData.service";

type NawaraGabesPipelineProps = {
  map: MapType;
  mapLoaded: boolean;
  layerId: string;
  geojsonName: string;
  color?: string;
  lineWeight: number;
  lineType?: string;
};

function LineLayer({ map, mapLoaded, geojsonName, layerId, color, lineWeight = 3, lineType}: NawaraGabesPipelineProps) {
  const mapCurrent = map.current;

  useEffect(() => {
    if (!mapLoaded || !mapCurrent) return;
    getGeoJsonByName(geojsonName).then((res) => {
      if (res.statusCode === 500) {
        console.error("500 Error: data not available");
      } else {
        // setGovData(res);
        if(mapGetSourceExists(mapCurrent, layerId) || mapGetLayerExists(mapCurrent, layerId)){return}
        // mapRemoveLayerSource(mapCurrent, [NARAWA_GABES_PIPELINE]);
        mapCurrent.addSource(layerId, {
          type: "geojson",
          data: res,
        });
        mapCurrent.addLayer({
          id: layerId,
          type: "line",
          source: layerId,
          layout: { visibility: "visible" },
          paint: {
            "line-color": color,
            "line-width": lineWeight,
            },
        });
        //add line type if exists in the layer definition
        if (lineType && lineType == 'dashed') {
          mapCurrent.setPaintProperty(layerId, "line-dasharray", [2,2]);
        }        
        mapCorrectLayerOrder(mapCurrent, LAYER_ORDER_ARRAY)
      }
    });
  },);



  return null;
}

export default LineLayer;